import React from 'react';
import './StatsBar.css';

export default function StatsBar({ stats, lastFetch }) {
  const timeStr = lastFetch
    ? lastFetch.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    : '—';

  return (
    <div className="stats-bar">
      <StatCard label="Total Events" value={stats.total || '—'} />
      <StatCard label="Active Fires" value={stats.open || '—'} variant="fire" />
      <StatCard label="Resolved" value={stats.closed || '—'} variant="muted" />
      <StatCard label="Regions Est." value={stats.regions || '—'} variant="amber" />
      <StatCard label="Last Updated" value={timeStr} variant="time" className="stat-time" />
    </div>
  );
}

function StatCard({ label, value, variant, className }) {
  return (
    <div className={`stat-card ${variant ? `stat-${variant}` : ''} ${className || ''}`}>
      <span className="stat-label">{label}</span>
      <span className="stat-value">{value}</span>
    </div>
  );
}
